import React, { useEffect } from 'react'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import PropTypes from 'prop-types'

//
// vendors libs
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CInvalidFeedback,
  CAlert
} from '@coreui/react'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { css } from "@emotion/core";
import { CIcon } from '@coreui/icons-react'
import BarLoader from "react-spinners/BarLoader";

//
// helpers
import { history } from '../../helpers';

//
// redux-saga files
import { actions as authActions } from '../../redux/modules/auth'

//
// selectors
import * as authSelectors from '../../redux/selectors/auth'

//
// prop types def
const propTypes = {
  errorMessage: PropTypes.string,
  login: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  token: PropTypes.string
}

//
// component body
function Login(props) {
  const override = css`
    display: block;
    margin: 0 auto;
    margin-top: 25px;
  `;

  useEffect(() => {
    if (props.token !== null) {
      history.push('/')
    }
  }, [props.token])

  const handleSubmit = values => {
    const { login } = props
    login(values.email, values.password)
  }

  const getValidationShema = () => {
    return Yup.object().shape({
      email: Yup.string()
        .required()
        .email(),
      password: Yup.string().required("Por favor digite sua senha")
    })
  }

  //
  // props
  const { loading, error, errorMessage } = props

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="8">
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <Formik initialValues={{}} validationSchema={getValidationShema} onSubmit={values => { handleSubmit(values) }}>
                    {({ values, errors, handleChange, handleSubmit }) => {
                      return (
                        <CForm onSubmit={handleSubmit}>
                          <h1>Login</h1>
                          <p className="text-muted">Entre com sua conta</p>
                          <CAlert show={error} color="danger">
                            {errorMessage}
                          </CAlert>
                          <CInputGroup className="mb-3">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <CIcon name={'cilUser'} />
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            {/* <CInput name="email" invalid={submitted && !email} type="email" placeholder="E-mail" autoComplete="email" value={email} onChange={handleChange} /> */}
                            <CInput name="email" invalid={errors.email} type="email" placeholder="E-mail" autoComplete="email" value={values.email} onChange={handleChange} />
                            <CInvalidFeedback>E-mail é necessário</CInvalidFeedback>
                          </CInputGroup>
                          <CInputGroup className="mb-4">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <CIcon name="cil-lock-locked" />
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput name="password" type="password" invalid={errors.password} placeholder="Senha" autoComplete="none" value={values.password} onChange={handleChange} />
                            <CInvalidFeedback>Password  é necessário</CInvalidFeedback>
                          </CInputGroup>
                          <CRow>
                            <CCol xs="12">
                              <CButton type="submit" color="primary" className="px-4">Entrar</CButton>
                              <BarLoader css={override} className="loaderSpinner" width={200} height={5} color={"#cecece"} loading={loading} />
                            </CCol>
                          </CRow>
                        </CForm>
                      )
                    }}
                  </Formik>
                </CCardBody>
              </CCard>
              <CCard className="text-white bg-primary py-5 d-md-down-none" style={{ width: '44%' }}>
                <CCardBody className="text-center">
                  <div>
                    <img alt="" src="/assets/img/favicon_200x200.png" />
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

const mapStateToProps = (state, props) => ({
  error: authSelectors.error(state, props),
  loading: authSelectors.loading(state, props),
  errorMessage: authSelectors.errorMessage(state, props),
  token: authSelectors.token(state, props),
})

const mapDispatchToProps = dispatch => ({
  login: (username, password) => dispatch(authActions.login(username, password))
})

Login.propTypes = propTypes
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login)
)
